import { FunctionComponent } from 'react';

import { AccountModel } from 'models';

import { MultiSelectNgField, MultiSelectNgFieldProps } from 'core/ui/MultiSelectNg';

/**
 * Props for AccountMultiSelect component
 */
export type AccountMultiSelectProps = Omit<MultiSelectNgFieldProps<AccountModel>, 'textField' | 'dataItemKey'> & {
  data: AccountModel[];
};

/**
 * React Hook Form compatible AccountMultiSelect component
 *
 * Pre-configured wrapper around MultiSelectNgField for AccountModel data.
 * Uses 'name' as textField and 'id' as dataItemKey, with custom tag rendering enabled.
 *
 * @example
 * <AccountMultiSelect
 *   data={accounts}
 *   name="selectedAccounts"
 *   required
 *   onChange={handleAccountChange}
 * />
 */
export const AccountMultiSelect: FunctionComponent<AccountMultiSelectProps> = (props) => {
  return <MultiSelectNgField {...props} textField="name" dataItemKey="id" enableCustomTagRender={true} requiredMessage="Account is required" />;
};
